// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2bBWI","content":"styles_content__ZNrqR","selectAll":"styles_selectAll__2IplK"};